import * as React from 'react';
import {AppRouting} from '../../AppConstants';
import {NavLink} from 'react-router-dom';
import styles from './Sidebar.module.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faCircleUser,
    faListCheck,
    faBarsStaggered,
    faCheckDouble
} from '@fortawesome/free-solid-svg-icons';
import {authService} from '../../index';
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {Popup} from "devextreme-react";
import {useCallback, useMemo, useState} from "react";
import {ToolbarItem} from "devextreme-react/popup";

type Routes = {
    url: string,
    icon: IconDefinition,
}
export const Sidebar = () => {
    const routes: Routes[] = [
        {
            url: AppRouting.Tickets,
            icon: faListCheck
        },
        {
            url: AppRouting.Tasks,
            icon: faBarsStaggered
        },
        {
            url: AppRouting.Logs,
            icon: faCheckDouble
        },
    ];

    const [popupVisible, setPopupVisible] = useState(false);

    const _signOut = useCallback(() => {
        setPopupVisible(false);
        void authService.signOut();
    }, []);

    const _showInfo = useCallback(() => {
        setPopupVisible(true);
    }, []);

    const renderPopup = useCallback(() => (
        <div className={styles.popup}>
            <div className={styles.group}>
                <b>Name</b>
                {authService.tokenInfo?.name}
            </div>
            <div className={styles.group}>
                <b>Email</b>
                {authService.tokenInfo?.email}
            </div>
            <div className={styles.group}>
                <b>Role</b>
                {authService.tokenInfo?.extension_Role}
            </div>
        </div>
    ), []);

    const _onHiding = useCallback(() => {
        setPopupVisible(false);
    }, []);

    const bookButtonOptions = useMemo(() => ({
        width: 100,
        text: 'Ok',
        type: 'default',
        stylingMode: 'contained',
        onClick: _onHiding,
    }), [_onHiding]);

    const logOutButtonOptions = useMemo(() => ({
        icon:'runner',
        text:'Sign Out',
        rtlEnabled:true,
        type: 'default',
        stylingMode:'text',
        onClick: _signOut,
    }), [_signOut]);

    return (
        <>
            <div className={styles.sidebar}>
                <div className={styles.menu}>
                    {routes.map(route => {
                        const {icon, url} = route;
                        return (
                            <NavLink key={url} className={styles.link} activeClassName={styles.active} to={url}>
                                <FontAwesomeIcon icon={icon} className={styles.icon}/>
                            </NavLink>
                        );
                    })}
                    <div className={styles.link} onClick={_showInfo}>
                        <FontAwesomeIcon icon={faCircleUser} className={styles.icon}/>
                    </div>
                </div>
            </div>
            <Popup
                showTitle={true}
                title="User Info"
                dragEnabled={false}
                hideOnOutsideClick={true}
                height="auto"
                maxWidth={360}
                visible={popupVisible}
                onHiding={_onHiding}
                contentRender={renderPopup}
                showCloseButton={false}
            >
                <ToolbarItem
                    widget="dxButton"
                    toolbar="top"
                    location="after"
                    cssClass={styles.logOut}
                    options={logOutButtonOptions}
                />

                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="center"
                    options={bookButtonOptions}
                />
            </Popup>
        </>
    );
};
